<template>
  <v-card flat max-width="1280" class="pl-md-6">
    <guide-tour config-key="message.store">
      <div>
        ∙ 以下為現有點數額度和儲值紀錄，NT$1等同1點，可同時用於簡訊發送和語音發送
      </div>
      <div>
        ∙ 簡訊發送一則為 NT$1 (1點)，語音發送一通為 NT$3 (3點)
      </div>
      <div>
        ∙ 語音訊息撥出後，患者有接通才會扣除點數
      </div>
      <div>
        ∙ 若要新增額度，歡迎點擊按鈕聯繫客服儲值
      </div>
    </guide-tour>

    <div class="px-4 mt-4 sms-refill-log">
      <template v-if="showActiveQuota">
        <dentco-alert-bar
          :message="quotaMessage"
          :btn-link="$enum.DENTCO_CS_LINE"
          :loading="quotaLoading"
          btn-title="聯繫牙醫小幫手儲值"
        />
      </template>
      <template v-else-if="showDisabledQuota">
        <v-sheet
          outlined
          rounded
          class="d-flex align-center pa-4 sms-refill-log__disabled-banner"
          :class="{'flex-wrap': $vuetify.breakpoint.xsOnly}"
          style="background-color: var(--sms-disabled-banner-bg); border-color: var(--sms-disabled-accent);"
        >
          <v-icon class="mr-3 sms-refill-log__disabled-banner-icon">
            mdi-information-outline
          </v-icon>
          <div
            class="sms-refill-log__disabled-banner-content"
            :class="{'mb-3': $vuetify.breakpoint.xsOnly}"
          >
            <div class="sms-refill-log__disabled-banner-title">
              簡訊功能目前已關閉，點數保留中
            </div>
            <div class="sms-refill-log__disabled-banner-body">
              如需重新使用，請聯繫客服開通簡訊功能
            </div>
          </div>
          <v-btn
            depressed
            class="sms-refill-log__disabled-banner-btn ml-auto"
            :class="{'ml-0': $vuetify.breakpoint.xsOnly}"
            :href="$enum.DENTCO_CS_LINE"
            style="background-color: var(--sms-disabled-accent); color: var(--sms-disabled-white);"
            target="_blank"
          >
            聯繫客服重新開通
          </v-btn>
        </v-sheet>
        <v-sheet outlined rounded class="mt-4 sms-refill-log__disabled-quota">
          <v-card
            flat
            class="d-flex align-center pa-5 sms-refill-log__disabled-quota-card"
            :class="{'flex-wrap': $vuetify.breakpoint.xsOnly}"
            style="background-color: var(--sms-disabled-surface);"
          >
            <v-overlay :value="quotaLoading" absolute>
              <v-progress-circular
                indeterminate
                size="32"
              ></v-progress-circular>
            </v-overlay>
            <div
              v-if="!quotaLoading"
              class="d-flex align-center grey-6--text font-weight-medium"
              :class="{'mb-4': $vuetify.breakpoint.xsOnly}"
            >
              <v-icon class="mr-3 sms-refill-log__disabled-quota-icon">mdi-piggy-bank-outline</v-icon>
              <span>目前保留點數：{{ quota }} 點（暫不可用）</span>
            </div>
            <v-btn
              outlined
              depressed
              class="sms-refill-log__disabled-quota-btn ml-auto"
              :class="{'ml-0': $vuetify.breakpoint.xsOnly}"
              :href="$enum.DENTCO_CS_LINE"
              style="background-color: var(--sms-disabled-white); border-color: var(--sms-disabled-button-border); color: var(--sms-disabled-text);"
              target="_blank"
            >
              聯繫牙醫小幫手儲值
            </v-btn>
          </v-card>
        </v-sheet>
      </template>
      <v-sheet
        v-else
        outlined
        rounded
        color="grey-4"
        class="pa-5 sms-refill-log__status-loading"
      >
        <v-progress-circular
          indeterminate
          color="grey-5"
          size="32"
        ></v-progress-circular>
      </v-sheet>
      <div v-if="showStoreLog" class="mt-8 pb-4">
        <div class="mt-2">
          <v-data-table
            :headers="headers"
            :items="logData"
            :footer-props="{itemsPerPageOptions: [10, 20, 50]}"
            fixed-header
            height="calc(100vh - 320px)"
          >
            <template v-slot:item.quota="{ item }">
              {{ item.quota }} 點
            </template>
          </v-data-table>
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
import { getSmsQuotaAPI, getSmsStatus, getSmsStoreLogsAPI } from '../../api';
import { mapGetters, mapMutations } from 'vuex';
import DentcoAlertBar from "../../components/utils/DentcoAlertBar.vue";
import GuideTour from "../../components/utils/GuideTour.vue";

export default {
  name: "SmsRefillLog",

  components: {GuideTour, DentcoAlertBar},

  data() {
    return {
      logData: [],
      quota: 0,
      quotaLoading: true
    }
  },

  computed: {
    ...mapGetters([
      'axiosParamData',
      'clinicUser',
      'smsStatusLoaded',
      'smsStatus'
    ]),
    showActiveQuota() {
      return this.smsStatus === true
    },
    showDisabledQuota() {
      return this.smsStatus === false
    },
    showStoreLog() {
      return this.smsStatus === true || this.smsStatus === false
    },
    quotaMessage() {
      return `${this.clinicUser ? '診所' : ''}可使用點數額度：${this.quota} 點`
    },
    headers() {
      return [
        {text: '儲值日期', align: 'center', value: 'create_time', sortable: true},
        {text: '儲值點數', align: 'center', value: 'quota', sortable: false},
        {text: '儲值類別', align: 'center', value: 'type', sortable: false},
      ]
    }
  },

  methods: {
    ...mapMutations({
      setSmsStatus: 'setSmsStatus'
    }),
    getLog() {
      getSmsStoreLogsAPI(this.axiosParamData).then(res => {
        this.logData = res.data
      })
    },

    getQuota() {
      this.quotaLoading = true
      getSmsQuotaAPI(this.axiosParamData).then(res => {
        this.quota = res.data.quota
      }).finally(() => {
        this.quotaLoading = false
      })
    }
  },

  mounted() {
    this.getLog()
    this.getQuota()

    if (!this.smsStatusLoaded) {
      getSmsStatus(this.axiosParamData).then(res => {
        this.setSmsStatus(res.data.sms_status)
      })
    }
  }
}
</script>

<style scoped>
.sms-refill-log {
  --sms-disabled-accent: #DC4D3F;
  --sms-disabled-accent-dark: #B12C20;
  --sms-disabled-banner-bg: #FFEDED;
  --sms-disabled-border: #E5E4E1;
  --sms-disabled-button-border: #D1D0CD;
  --sms-disabled-muted: #9C9B99;
  --sms-disabled-surface: #F5F4F1;
  --sms-disabled-text: #6D6C6A;
  --sms-disabled-white: #FFFFFF;
}

.sms-refill-log__disabled-banner {
  background-color: var(--sms-disabled-banner-bg);
  border-color: var(--sms-disabled-accent);
}

.sms-refill-log__disabled-banner-icon {
  color: var(--sms-disabled-accent-dark);
}

.sms-refill-log__disabled-banner-content {
  flex: 1;
  min-width: 0;
}

.sms-refill-log__disabled-banner-title {
  color: var(--sms-disabled-accent-dark);
  font-size: 13px;
  font-weight: 700;
  line-height: 1.4;
}

.sms-refill-log__disabled-banner-body {
  color: var(--sms-disabled-text);
  font-size: 12px;
  line-height: 1.5;
}

.sms-refill-log__disabled-banner-btn {
  background-color: var(--sms-disabled-accent);
  color: var(--sms-disabled-white);
  font-size: 12px;
  font-weight: 600;
  min-width: 125px;
}

.sms-refill-log__disabled-quota {
  border-color: var(--sms-disabled-border);
}

.sms-refill-log__disabled-quota-card {
  background-color: var(--sms-disabled-surface);
  min-height: 72px;
  position: relative;
}

.sms-refill-log__disabled-quota-icon {
  color: var(--sms-disabled-muted);
}

.sms-refill-log__disabled-quota-btn {
  background-color: var(--sms-disabled-white);
  border-color: var(--sms-disabled-button-border);
  color: var(--sms-disabled-text);
  font-size: 12px;
  font-weight: 600;
}

.sms-refill-log__status-loading {
  align-items: center;
  background-color: var(--v-grey-2-base);
  display: flex;
  justify-content: center;
  min-height: 72px;
}
</style>
